export default __webpack_public_path__ + "static/media/transaction.f7c1df52.svg";